import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import "./index.css";
import "./styles/global.css";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "react-oidc-context";
import { ThemeProvider } from "@mui/material";
import theme from "./theme";

// const cognitoAuthConfig = {
//   authority: "https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_bELMwmzr5",
//   client_id: "6euop5924vo5uo66a92efvimm6",
//   redirect_uri: "https://d84l1y8p4kdic.cloudfront.net",
//   response_type: "code",
//   scope: "email openid phone",
// };
// const cognitoAuthConfig = {
//   identityPoolId: "eu-west-1:6fa67ad8-d6ad-4605-8d2e-cbbb35a71723",
//   region: "eu-west-1",
//   authority: "",
//   client_id: "",
//   redirect_uri: "",
//   response_type: "code",
//   scope: "email openid phone",
// };

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <AuthProvider>
    <ThemeProvider theme={theme}>
      <Router>
        <App />
      </Router>
    </ThemeProvider>
  </AuthProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
